export enum DossierStatus {
    Active = "Active",
    Archived = "Archived",
}
